<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">MI QR</b-card-header>
      <b-card-body>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-12 text-right">
            <button @click="exportar" class="btn btn-success">Exportar</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <!-- <base-input disabled v-model="saldos.FormatedAmount"></base-input> -->
            <img
              v-bind:src="'data:'+imagen.ImageType+';base64,' + imagen.QRBase64"
              class="responsiveImage"
            />
            <!-- <pdf :src="'data:application/pdf;base64,'+pdfResp.pdfResp> </pdf> -->
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
.responsiveImage {
  max-width: 40%;
  width: auto;
  height: auto;
}
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import fileHelpers from "@/helpers/fileHelpers";
import pdf from "vue-pdf";

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

export default {
  components: { pdf },
  data() {
    return {
      imagen: { ImageType: "", QRBase64: "" }
    };
  },
  methods: {
    exportar() {
      let context = this;

      axiosHelpers.axiosGet("Account/ExportAccountQR", {}, this, function(
        data
      ) {
        var bytesBase64 = data.ResponseVM.ReportBytes;

        var fileName = "MiQR.pdf";
        var appType = "application/pdf";

        fileHelpers.downloadFile(context, bytesBase64, fileName, appType);
      });
    }
  },
  beforeMount: function() {
    let context = this;

    axiosHelpers.axiosGet("Account/GetAccountQR", {}, this, function(data) {
      context.imagen = data.ResponseVM;

      if (data.Alerts.length != 0) {
        context.$router.push("dashboard");
      }
    });
  }
};
</script>